import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Next Steps\n          ")
], -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("p", null, "Who will be providing first line approval for this employee amend? *", -1);
const _hoisted_5 = { class: "col-span-6" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = { class: "px-4 py-3 bg-gray-50 text-right sm:px-6" };
const _hoisted_8 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_user_search = _resolveComponent("user-search");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_user_search, {
                        "selected-email": _ctx.model.firstLineApproverEmail,
                        "onUpdate:selectedEmail": _cache[0] || (_cache[0] = ($event) => ((_ctx.model.firstLineApproverEmail) = $event)),
                        group: "HM",
                        "read-only": _ctx.isFirstLineSelected,
                        onUpdatedUser: _cache[1] || (_cache[1] = ($event) => (_ctx.handleUser($event)))
                    }, null, 8, ["selected-email", "read-only"])
                ]),
                _createTextVNode(),
                _createElementVNode("button", {
                    class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                    disabled: !_ctx.formData.firstLineApproverEmail,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.handleSaveForm && _ctx.handleSaveForm(...args)), ["prevent"]))
                }, "\n          Save\n        ", 8, _hoisted_6)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                    type: "submit",
                    class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                    disabled: !_ctx.canComplete,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                }, "\n          Complete Amend\n        ", 8, _hoisted_8)
            ])
        ])
    ]));
}
